// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__kdC2w","wrapper":"Tabs_wrapper__nFKX3","button":"Tabs_button__inO41","active":"Tabs_active__IT5bJ"};